/**
 * Dynamically loads an external script tag into the document.
 * Handles idempotent loading and URL changes (e.g. PayPal's dynamic client-id).
 */
export function loadScript(src: string, id: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.getElementById(id) as HTMLScriptElement | null;

    if (existing) {
      // If same src, script is already loaded
      if (existing.src === src) {
        resolve();
        return;
      }
      // Different src — remove old script so we can load the new one
      existing.remove();
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}
